/** @format */

import styled from 'styled-components';

export const StyledTbody = styled.tbody``;
